import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import { useTranslation } from 'react-i18next';
import LogoIcon from '../Logo/LogoIcon';

const SupportChatToggle = forwardRef(({ onClick, count, className }, ref) => {
  const cn = useClassNames(
    () => [
      'rounded-full',
      'px-3',
      'lg:px-2',
      'lg:py-1',
      'bg-blue-50',
      'border-blue-500',
      'border',
      'hover:bg-blue-100',
      'hover:text-blue-900',
      'text-blue-800',
      'font-semibold',
      'flex',
      'items-center',
      'leading-none',
      'gap-1',
      className,
    ],
    [className],
  );

  const { t } = useTranslation('components', { keyPrefix: 'PhysicianTitleBar' });

  return (
    <button type="button" className={cn} onClick={onClick} ref={ref}>
      <LogoIcon className="w-5 h-5" />
      <span className="hidden lg:block">{t('support')}</span>
      {count > 0 && (
        <span className="ml-1 bg-red-500 text-white px-2 py-1 rounded-full">{count}</span>
      )}
    </button>
  );
});

SupportChatToggle.propTypes = {
  onClick: PropTypes.func,
  count: PropTypes.number,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

SupportChatToggle.defaultProps = {
  onClick: () => {},
  count: 0,
  className: [],
};

export default SupportChatToggle;
